// extracted by mini-css-extract-plugin
export default {"userName":"ci57tWE87w8UTdrY1nNm","userNameAvatar":"gr9g__1vC2k2TtkiUvYt","userNameCaption":"W4CghtrN8XYDz613pyrp"};